import { render, staticRenderFns } from "./SwitchExtended.vue?vue&type=template&id=51ddbb24&"
import script from "./SwitchExtended.vue?vue&type=script&lang=js&"
export * from "./SwitchExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports